import type { SiteControllerSettingBaseFormModel } from "@/components/features/settings/site-controller/model/base/type";
import type { SiteControllerSettingTllFormModel } from "@/components/features/settings/site-controller/model/tl-lincoln/type";
import type { SiteControllerSettingTLLincolnFormModelMethodsType } from "@/components/features/settings/site-controller/model/tl-lincoln/use-case/use-create-model/methods";

import { SettingsSiteControllerTLLPlanMapping } from "./plan-mapping";
import { SettingsSiteControllerTLLRoomMapping } from "./room-mapping";
import { SettingsSiteControllerTllID } from "./set-up-room-price-by-chillnn";

type Props = {
	tlLincolnViewModel: SiteControllerSettingTllFormModel["ViewModel"];
	siteControllerSettingTLLincolnFormModelMethods: SiteControllerSettingTLLincolnFormModelMethodsType;

	roomKVList: SiteControllerSettingBaseFormModel["QueryData"]["roomKVList"];
};

export const SettingsSiteControllerTlLincolnMainSection = ({
	tlLincolnViewModel,
	siteControllerSettingTLLincolnFormModelMethods: _siteControllerSettingTLLincolnFormModelMethods,
	roomKVList,
}: Props) => {
	const { siteControllerSettingTLLFormModelMethods } = _siteControllerSettingTLLincolnFormModelMethods;

	return (
		<>
			<SettingsSiteControllerTllID
				tllID={tlLincolnViewModel.tll.tllID}
				onSetTllID={siteControllerSettingTLLFormModelMethods.onSetTllID}
			/>
			<SettingsSiteControllerTLLRoomMapping
				rooms={tlLincolnViewModel.tll.rooms}
				onSetChillnnRoomID={siteControllerSettingTLLFormModelMethods.onSetChillnnRoomID}
				roomKVList={roomKVList}
			/>
			<SettingsSiteControllerTLLPlanMapping
				rooms={tlLincolnViewModel.tll.rooms}
				plans={tlLincolnViewModel.tll.plans}
				defaultPlan={tlLincolnViewModel.tll.defaultPlan}
				onSetDefaultPlan={siteControllerSettingTLLFormModelMethods.onSetDefaultPlan}
			/>
		</>
	);
};

SettingsSiteControllerTlLincolnMainSection.displayName = "SettingsSiteControllerTlLincolnMainSection";
